import { useEffect, useState } from "react";
import "../assets/styles/views/pv-list.scss";
import { useLocation, useOutletContext } from "react-router-dom";
import {
  districts_list,
  get_hierarchy_info,
  get_pv_list,
  rcr_area,
} from "../utils/endpoints";
import PvCard from "../components/PvCard";
import BackArrowButton from "../components/BackArrowButton";

export default function PvList() {
  const [context, setContext] = useOutletContext();
  const [districts, setDistricts] = useState();
  const [selected_district, setSelectedDistrict] = useState();
  const [cavr, setCavr] = useState();
  const [selected_cavr, setSelectedCavr] = useState();
  const [rcr, setRcr] = useState();
  const [selected_rcr, setSelectedRcr] = useState();
  const [pv_list, setPvList] = useState();
  const [initial_load, setInitialLoad] = useState(true);
  const [role, setRole] = useState();

  const location = useLocation();

  const getHierarchy = async (id) => {
    const response = await context.httpRequest(
      "get",
      rcr_area.replace("*", id),
      null,
      context.session.token
    );
    return response;
  };

  const loadDistricts = async () => {
    let response = await context.httpRequest(
      "get",
      districts_list,
      null,
      context.session.token
    );
    if (response.result) {
      if (location.state && initial_load) {
        let last_district_selected = response.data.find(
          (x) => x.codice === location.state.pv.codiceDistrict
        ).id;
        setSelectedDistrict(last_district_selected);
      }
      return response.data;
    }
    return response;
  };

  const loadUserHierarchyInfo = async () => {
    let response = await context.httpRequest(
      "get",
      get_hierarchy_info,
      null,
      context.session.token
    );
    if (response.result) {
      return response.data;
    }
    return response;
  };

  useEffect(() => {
    if (role) {
      (async () => {
        if (role == "ADMIN" || role == "GUEST" || role == "TAS") {
          let districts = await loadDistricts();
          if (districts) {
            setDistricts(districts);
          }
        } else {
          const hierarchy_info = await loadUserHierarchyInfo();
          switch (role) {
            case "DM":
              setSelectedDistrict(hierarchy_info.id);
              break;
            case "AM":
              setSelectedCavr(hierarchy_info.id);
              break;
            case "RCR":
              setSelectedRcr(hierarchy_info.id);
              break;
          }
        }
      })();
    }
  }, [role]);

  useEffect(() => {
    if (!!context.session) {
      setRole(context.session.profileTypeCode);
    }
  }, [context.session]);

  useEffect(() => {
    setCavr();
    setRcr();
    setSelectedCavr("");
    setSelectedRcr("");
    if (selected_district) {
      (async () => {
        const response = await getHierarchy(selected_district);
        if (response.result) {
          setCavr(response.data);
          if (location.state && initial_load) {
            let last_cavr_selected = response.data.find(
              (x) => x.codice === location.state.pv.codiceArea
            ).id;
            setSelectedCavr(last_cavr_selected);
          }
        }
      })();
    }
  }, [selected_district]);

  useEffect(() => {
    setRcr();
    setSelectedRcr("");
    if (selected_cavr) {
      (async () => {
        const response = await getHierarchy(selected_cavr);
        if (response.result) {
          setRcr(response.data);
          if (location.state && initial_load) {
            let last_rcr_selected = response.data.find(
              (x) => x.codice === location.state.pv.loginRcr
            ).id;
            setSelectedRcr(last_rcr_selected);
            setInitialLoad(false);
          }
        }
      })();
    }
  }, [selected_cavr]);

  useEffect(() => {
    setPvList();
    if (selected_rcr) {
      setContext({ loader: true });
      (async () => {
        const response = await context.httpRequest(
          "get",
          get_pv_list.replace("*", selected_rcr),
          null,
          context.session.token
        );
        if (response.result) setPvList(response.data);
        setContext({ loader: false });
      })();
    }
  }, [selected_rcr]);

  return (
    <>
      <BackArrowButton path="/" />
      <section className="pv-list w-100 flex-md-wrap px-md-3 d-flex">
        <h1 className="pv-list__title px-3 mt-3 mt-md-4 mb-3 text-start text-md-center">
          Gestione checklist - Selezione del Punto Vendita
        </h1>
        {role && role !== "RCR" ? (
          <div className="pv-list__filters-container position-sticky p-3 mx-3 mx-md-auto border shadow-sm">
            {role === "ADMIN" || role == "GUEST" || role == "TAS" ? (
              <>
                <label>DISTRETTO</label>
                <select
                  name="districts"
                  onChange={(e) => setSelectedDistrict(e.target.value)}
                  className="w-100 mb-3"
                  required
                  value={selected_district}
                >
                  <option value="">Seleziona..</option>
                  {districts
                    ? districts.map((item, index) => {
                        return (
                          <option value={item.id} key={index}>
                            {item.nome}
                          </option>
                        );
                      })
                    : null}
                </select>
              </>
            ) : null}
            {["ADMIN", "DM", "GUEST","TAS"].includes(role) ? (
              <>
                <label>CAVR</label>
                <select
                  disabled={!!selected_district ? false : true}
                  name="cavr"
                  onChange={(e) => setSelectedCavr(e.target.value)}
                  className="w-100 mb-3"
                  required
                  value={selected_cavr}
                >
                  <option value="">Seleziona..</option>
                  {cavr
                    ? cavr.map((item, index) => {
                        return (
                          <option value={item.id} key={index}>
                            {item.type} {item.nome}
                          </option>
                        );
                      })
                    : null}
                </select>
              </>
            ) : null}

            <label>RCR</label>
            <select
              disabled={!!selected_cavr ? false : true}
              name="rcr"
              onChange={(e) => setSelectedRcr(e.target.value)}
              className="w-100"
              required
              value={selected_rcr}
            >
              <option value="">Seleziona..</option>
              {rcr
                ? rcr.map((item, index) => {
                    return (
                      <option value={item.id} key={index}>
                        {item.rcrCognome} {item.rcrNome}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>
        ) : null}

        {pv_list ? (
          pv_list.length > 0 ? (
            <strong className="pv-list__search-title d-none d-md-block w-100 text-center mt-3 mt-md-5">
              Seleziona punto vendita
            </strong>
          ) : (
            <span className="pv-list__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
              Nessun risultato da mostrare
            </span>
          )
        ) : (
          <span className="pv-list__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
            Compila tutti i filtri per proseguire
          </span>
        )}

        <div
          className={`pv-list__container-list mb-md-5 ${
            role !== "RCR" ? "mt-4" : "mt-md-4"
          } d-md-flex flex-md-wrap main-panel w-100 p-3 p-md-0`}
        >
          {pv_list ? (
            pv_list.length > 0 ? (
              <>
                <strong className="d-block d-md-none mb-3">
                  Seleziona punto vendita
                </strong>
                {pv_list.map((item, index) => {
                  return <PvCard pv_info={item} key={index} />;
                })}
              </>
            ) : (
              <span className="d-block d-md-none w-100 text-center mt-5">
                Nessun risultato da mostrare
              </span>
            )
          ) : (
            <span className="d-block d-md-none w-100 text-center mt-5">
              {role !== "RCR"
                ? "Compila tutti i filtri per proseguire"
                : "Nessun risultato da mostrare"}
            </span>
          )}
        </div>
      </section>
    </>
  );
}
